import { AxiosInstance } from 'axios';
import {
  AccountsReceivableSalesJournalReportServiceType,
  initAccountsReceivableSalesJournalReportService,
} from '../pages/AccountsReceivableSalesJournalReportPage/api';
import {
  AgencyPerfermanceOverviewReportServiceType,
  initAgencyPerfermanceOverviewReportService,
} from '../pages/AgencyPerfermanceOverviewReportPage/api';
import {
  FinancialAccountReportServiceType,
  initFinancialAccountReportService,
} from '../pages/FinancialAccountReportPage/api';
import {
  TrialBalanceReportServiceType,
  initTrialBalanceReportService,
} from '../pages/TrialBalanceReportPage/api';

export interface FinancialReportServiceType {
  accountsReceivableSalesJournalReport: AccountsReceivableSalesJournalReportServiceType;
  trialBalanceReport: TrialBalanceReportServiceType;
  agencyPerfermanceOverviewReport: AgencyPerfermanceOverviewReportServiceType;
  financialAccountReport: FinancialAccountReportServiceType;
}

export const initFinancialReportService = (axios: AxiosInstance): FinancialReportServiceType => ({
  accountsReceivableSalesJournalReport: initAccountsReceivableSalesJournalReportService(axios),
  trialBalanceReport: initTrialBalanceReportService(axios),
  agencyPerfermanceOverviewReport: initAgencyPerfermanceOverviewReportService(axios),
  financialAccountReport: initFinancialAccountReportService(axios),
});
